module.exports = __webpack_public_path__ + "img/1c.34c7e2c6.png";